import { render, staticRenderFns } from "./AddMarketingActivityModal.vue?vue&type=template&id=bc087414&scoped=true&"
import script from "./AddMarketingActivityModal.vue?vue&type=script&lang=js&"
export * from "./AddMarketingActivityModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMarketingActivityModal.vue?vue&type=style&index=0&id=bc087414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc087414",
  null
  
)

export default component.exports